export default function asyncLoadJs(url) {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.src = url
    document.body.appendChild(script)
    script.onload = () => {
      resolve()
    }
    script.onerror = () => {
      reject()
    }
  })
}

export function loadTiandiJs() {
  return new Promise((resolve, reject) => {
    var key = '79dccd4afbad250daed37d498a0dc735'
    // asyncLoadJs('http://api.tianditu.gov.cn/api?v=4.0&tk=293ecf8e1b341fa2f19a4c8adfa80e02')
    // asyncLoadJs('https://api.tianditu.gov.cn/api?v=4.0&tk=' + key)
    asyncLoadJs('/tianMap/tiandiApi.js')
      .then(() => {
        asyncLoadJs('tianMap/d3.js')
        asyncLoadJs('tianMap/CarTrack.js')
        asyncLoadJs('tianMap/D3SvgOverlay.js')
        resolve()
      })
      .catch(err => {
        reject(err)
      })
  })
}

export function loadGoogleJS() {
  return new Promise((resolve, reject) => {
    // maps.googleapis.com 换成googleapis.gpdcloud.net
    asyncLoadJs('https://maps.googleapis.com/maps/api/js?key=AIzaSyD61QgYiXuY7-JV5PrGqdIsXiB8oNGpVk8&libraries=drawing')
      // .then(() => {
      //   return asyncLoadJs('https://webapi.amap.com/ui/1.0/main.js')
      // })
      .then(() => {
        resolve()
      })
      .catch(err => {
        reject(err)
      })
  })
}
